import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { ReportInfo } from '../../../Models/Models/Reports/ReportInfo';
import { IJsonDate } from '../../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class InvestmentTransactionReportClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(hierarchyId: string, modelId: number, fromDate: IJsonDate, toDate: IJsonDate, transSource: string, instrumentCode: string, cNoteID: number, sortName: string, sortDirection: string): Promise<ReportInfo, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Reports/Transaction/InvestmentTransactionReport/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, modelId: modelId, fromDate: fromDate, toDate: toDate, transSource: transSource, instrumentCode: instrumentCode, cNoteID: cNoteID, sortName: sortName, sortDirection: sortDirection }

    return AjaxWrapper.post<ReportInfo, any>(url, data);
  }
}

